import { useMutation } from "react-query";
import { editLeasedEquipment } from "../../../../actions/CarrierAgreementMgmt/LeasedEquipment";

const useEditLeasedEquipment = () => {
  return useMutation(editLeasedEquipment);
};

export default useEditLeasedEquipment;
